import { useEffect, useState } from 'react';
import { getProfile } from '../components/services/httpService';

const managerRoles = new Set( [ "MANAGER", "SUPERADMIN" ] );
const candidateRoles = new Set( [ "CANDIDAT", "CONSULTANT" ] );
const clientRoles = new Set( [ "CLIENT" ] );

export function useCurrentUserRoles() {
    const [ currentUser, setCurrentUser ] = useState( null );
    const [ isManagerRole, setIsManagerRole ] = useState( false );
    const [ isCandidateRole, setIsCandidateRole ] = useState( false );
    const [ isClientRole, setIsClientRole ] = useState( false );

    useEffect( () => {
            async function getCurrentUserRole() {
                const response = await getProfile();
                if ( !response.ok ) {
                    console.error( "Failed to fetch user profile:", response.status );
                    throw new Error( `Failed to fetch user profile: ${ response.status }` );
                }
                return await response.json();
            }

            const token = localStorage.getItem( "token" );
            if ( token ) {
                getCurrentUserRole()
                    .then( ( data ) => {
                        setCurrentUser( data );
                        setIsManagerRole( managerRoles.has( data.role ) );
                        setIsCandidateRole( candidateRoles.has( data.role ) );
                        setIsClientRole( clientRoles.has( data.role ) );
                    } )
                    .catch( ( error ) => console.error( error ) );
            }
        }, []
    );

    return { currentUser, isManagerRole, isCandidateRole, isClientRole };
}
